import styles from "./OnboardingPage.module.css"
import Navbar from "../../components/Navbar/NavbarOnboarding/Navbar";
import OnboardingForm from "../../components/Onboarding/OnboardingForm";
import { useOnboardingData } from "../../hooks/useOnboardingData";
import { useNavigate, useLocation } from 'react-router-dom'; 
import { useRef } from "react";
import { useEffect } from "react";
/**
* Onboarding page
* Contains onboarding form.
* @returns TSX.Element
*/
const OnboardingPage = () => {

    // Experimental !!!! -- po 2 reloadech to vymaze

    const { clearData } = useOnboardingData(); // Onboarding data
    const isFirstMount = useRef(true);

    useEffect(() => {
        // Clear data when entering onboarding (but not on first mount/reload)
        if (isFirstMount.current) {
            isFirstMount.current = false;
            // Don't clear on first mount (page reload)
            return;
        }
        
        // Clear data when navigating TO onboarding from another route
        clearData();
    }, []); // Empty dependency - only runs on mount

    useEffect(() => {
        // Clear data when leaving onboarding
        return () => {
            clearData();
        };
    }, []);

    return(
        <>
            <div className={styles.Page}>
                <div className={styles.Header}>
                    <Navbar/>
                </div>
                <div className={styles.OnboardingBlock}>
                <OnboardingForm/>
                </div>
            </div>
        </>
    )
};

export default OnboardingPage;
